import * as React from 'react';
import { Image } from '@cian/ui-kit';

import { NewbuildingFavoriteButton } from '../../../../../../../../containers/NewbuildingFavoriteButton';
import { NewbuildingDeleteButton } from '../../../../../../../../containers/NewbuildingDeleteButton';
import { Link } from '../../../../../../../Link';
import { trackNavigationToCardJK } from '../../../shared/tracking';
import * as style from './Photo.css';

export interface IPhotoProps {
  id: number;
  imageUrl: string;
  name: string;
  url: string;
  isFavorite: boolean;
  gaLabel?: string;
}

export const Photo = ({ id, imageUrl, name, url, isFavorite, gaLabel }: IPhotoProps): React.JSX.Element => {
  const handleNavigateToCardJK = React.useCallback(() => {
    trackNavigationToCardJK(id, 'desktop');
  }, [id]);

  return (
    <div className={style['container']}>
      <Link href={url} target="_blank" onClick={handleNavigateToCardJK}>
        <Image alt={name} borderRadius="16px" height={200} objectFit="cover" src={imageUrl} width="100%" />
      </Link>
      <div className={style['actions']}>
        <NewbuildingDeleteButton newbuildingId={id} size="M" />
        <NewbuildingFavoriteButton gaLabel={gaLabel} isFavorite={isFavorite} newbuildingId={id} />
      </div>
    </div>
  );
};
